import { render, staticRenderFns } from "./KinerjaKontrak.vue?vue&type=template&id=2803d372&"
import script from "./KinerjaKontrak.vue?vue&type=script&lang=js&"
export * from "./KinerjaKontrak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports